import { Button, Group, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

const NOTICE_ID = 'stale-build';
let showing = false;

/**
 * The page is older than the server it is talking to (see `utils/staleBuild.ts`). Offered,
 * never forced: the page rendered, and may hold an unsaved editor draft. One notice, however
 * many calls fail, and it stays until dismissed.
 */
export const showStaleBuildNotice = () => {
    if (showing) return;
    showing = true;
    notifications.show({
        id: NOTICE_ID,
        autoClose: false,
        onClose: () => {
            showing = false;
        },
        message: (
            <Group justify="space-between" gap="sm" wrap="wrap">
                <Text size="sm">Config Hub has been updated.</Text>
                <Button size="xs" onClick={() => window.location.reload()}>
                    Reload
                </Button>
            </Group>
        ),
    });
};
